import {connect} from 'react-redux';

import {
  makeMapStateToProps,
  wrapInShallowSelector,
} from '../../../../../../srcCommon/helpers/reselectHelpers';
import {ConversationModel} from '../../../../../models/api/conversationModel';
import {AppState} from '../../../../../store/appState';
import {makeGetTrackers} from '../../../../../store/data/conversations/conversationsSelectors';
import {getUser} from '../../../../../store/data/teammates/teammatesSelectors';
import {ConversationTopbarInvite} from './conversationTopbarInvite';

/*
 * Component.
 */

interface ConversationTopbarInviteContainerProps {
  conversation: ConversationModel;
}

/*
 * Selectors.
 */

function getConversation(_state: AppState, props: ConversationTopbarInviteContainerProps) {
  return props.conversation;
}
function getConversations(_state: AppState, props: ConversationTopbarInviteContainerProps) {
  return [props.conversation];
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ConversationTopbarInviteContainerProps>()(() => ({
  user: getUser,
  conversation: getConversation,
  trackers: makeGetTrackers(wrapInShallowSelector(getConversations)),
}));

export const ConversationTopbarInviteContainer = connect(mapStateToProps)(ConversationTopbarInvite);
